import registerIbDateFormatFilter from './dateformat'
import registerEllipsisFilter from './ellipsis';
import registerDefaultFilter from './default';
import registerEncodeHtmlFilter from './encodeHtml';
import registerCustomMediaBrowserFilter from './customMediaBrowserFilter';
import registerOrderObjectByFilter from './orderObjectBy';

export default function registerFilters(angular) {
    registerIbDateFormatFilter(angular.module('assessmentFrontendFilters'));
    registerEllipsisFilter(angular.module('assessmentFrontendFilters'));
    registerDefaultFilter(angular.module('assessmentFrontendFilters'));
    registerEncodeHtmlFilter(angular.module('assessmentFrontendFilters'));
    registerCustomMediaBrowserFilter(angular.module('assessmentFrontendFilters'));
    registerOrderObjectByFilter(angular.module('assessmentFrontendFilters'));
}